// extracted by mini-css-extract-plugin
export default {"container":"WeekDaysInput_container__v8TRN"};